// Author YuJiaBei
// Date 2020-10-10 14:00:25

import * as model from "@/model/sithMes/mst/SithMesMstPositionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstPosition(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesMstPosition',
        modelFilter: model.filter
    })
    .buildStore()
